import { defineComponent } from 'vue';
import AnnualProductionComponent from '@/components/AnnualProduction/AnnualProductionComponent.vue';
export default defineComponent({
    name: 'AnnualProduction',
    components: { AnnualProductionComponent },
    data() {
        return {};
    }
});
